@if (listing().series?.description) {
  <div
    class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm text-primary-500 px-4 py-5 sm:px-6 sm:py-6"
  >
    <app-listing-details-accordion accordionId="series-details" [title]="listing().series!.title">
      <div
        class="mt-4 [&>a]:text-blue-500 [&>a]:underline"
        [innerHTML]="listing().series!.description"
      ></div>
    </app-listing-details-accordion>
  </div>
}
